<template>
  <div v-if="fields"
    class="profile-fields"
  >
    <div v-for="(field, index) in fields" :key="`field-${index}`"
      class="profile-fields-row"
      :class="rowName(field)"
    >
      <template v-if="field.cfid">
        <!-- Custom field -->
        <span class="profile-fields-question">{{field.question}}</span>

        <span v-if="field.type=='TEXTAREA'" v-html="field.value"
          class="profile-fields-answer"
        ></span>
        <span v-else-if="field.type=='MULTISELECT'"
          class="profile-fields-answer"
        >{{field.value.join(', ')}}</span>
        <a v-else-if="field.type=='URL'" :href="field.value" target="_blank"
          class="profile-fields-answer"
        >{{field.value}}</a>
        <span v-else
          class="profile-fields-answer"
        >{{field.value}}</span>
      </template>
      <template v-else>
        <!-- Standard field: i18n for fieldnames -->
        <span class="profile-fields-question">{{trans(field.field)}}</span>
        <span class="profile-fields-answer" v-html="field.value"></span>
      </template>
    </div>
  </div>
</template>

<script>
// TEMPORARY NAME MAPPING UNTIL WE GET i18n WORKING
const FIELDS_EN = {
  'email': 'Email',
  'jobtitle': 'Job title',
  'mobile': 'Mobile',
  'linkedin': 'LinkedIn',
  
  'website': 'Website',
  'profile_teaser': 'Profile',
  'profile': 'Profile',
  'phone': 'Phone',
  'fax': 'Fax',
  'address1': 'Address ',
  'address2': 'Address ',
  'town': 'Town',
  'postcode': 'Postcode',
  'county': 'County/Province',
  'country': 'Country',
};

export default {
  name: "ProfileFields",
  props: {
    fields: {
      type: Array,
      default: null,
      required: false,
    },
    organisation: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    rowName(field) {
      if (Object.prototype.hasOwnProperty.call(field, 'cfid')) {
        return `profile-fields-cfid${field.cfid}`;
      } else {
        return `profile-fields-${field.field}`;
      }
    },
    trans(fieldName) {
      return FIELDS_EN[fieldName] ?? '';
    },
  },
  computed: {
  },
};
</script>

<style>
.profile-fields-row {
  display: grid;
  grid-template-columns: 20% [label] auto [value];
  /* display: flex;
  flex-direction: row; */
  gap: 0 10px;
  padding: 5px 0;
  border-top: 1px solid #eee;
}
.profile-fields-question {
  /* width: 30%; */
  min-width: fit-content;
}
.profile-fields-question::after {
  content: ':';
}
/* .profile-fields-answer {
  flex-grow: 1;
} */
</style>